import { observer } from 'mobx-react-lite'
import { AutomationLogExecutionStatusConfig } from 'entities/Integrations/ui/AutomationLogExecutionStatus'
import { type IAutomationLogExecutionStatus } from 'entities/Integrations'
import type { IFilterValue, IWidgetProps } from 'widgets/FilterEditor/types/types'
import { WidgetStatus } from 'widgets/FilterEditor/ui/Widget/WidgetStatus'

export const WidgetAutomationLogExecutionStatus = observer(
  (
    props: IWidgetProps<
      IFilterValue<IAutomationLogExecutionStatus>,
      IAutomationLogExecutionStatus[]
    >
  ) => {
    return (
      <WidgetStatus
        getConfigByStatus={(status) => AutomationLogExecutionStatusConfig[status]}
        {...props}
      />
    )
  }
)
